<ng-content [class.growrTab]="isGrowrTabComponent"></ng-content>
